import React, { useEffect, useState } from "react";
import SlackChannelList from "../../util/slack";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import Api from "../../../utils/api";
import {
  setSlackOptions,
  slackOptionsSelector,
} from "../../../redux/features/configSlice";
import { LeftPanel } from "../../Wrappers";
import Toaster from "../../Toaster/Index";
import { getCookie, updatePluginList } from "../../../utils/helper";
import { LTButton } from "@lambdatestincprivate/lt-components";

const SLACK_PLUGIN_ID = 2;

const Slack = () => {
  const sideBarObject: any = useSelector(
    (state: RootState) => state.config.sideBarObject
  );
  const slackOptions = useSelector(slackOptionsSelector);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const fetchSlackOptions = async () => {
    try {
      const res = await Api.installApi.commonInstall(sideBarObject.code, {
        plugin_id: SLACK_PLUGIN_ID,
      });
      dispatch(setSlackOptions(res));
      console.log("slack options in re-sync", res);
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    console.log("sidebar object in slack", sideBarObject);
    if (sideBarObject) {
      fetchSlackOptions();
    }
  }, [sideBarObject]);

  const handleSlackChannelSelect = (values: {
    channel_id: string;
    channel_name: string;
  }) => {
    console.log("channel changed in pipeline", values);
    setSelectedSlackChannel(values);
  };
  const [selectedSlackChannel, setSelectedSlackChannel] = useState<{
    channel_id: string;
    channel_name: string;
  }>();

  const InstallSlackPlugWithChannel = async () => {
    if (selectedSlackChannel) {
      const res = await Api.commonApi.postDefaultChannel({
        channel_id: selectedSlackChannel.channel_id,
        channel_name: selectedSlackChannel.channel_name,
        plugin_id: SLACK_PLUGIN_ID,
      });
      Toaster.success(res.message);
      console.log("Api.commonApi.postDefaultChannel in pipeline", res);
      if (res.url) {
        window.open(res.url, "_self");
      }
    }

    setIsLoading(false);
    await updatePluginList();

    const redirectToValue = getCookie("redirectTo");
    if (redirectToValue && redirectToValue !== "") {
      const url = decodeURIComponent(redirectToValue);
      window.location.href = url;
    }
    dispatch(setSlackOptions(null));

    return;
  };

  return (
    <LeftPanel>
      <SlackChannelList
        slackOptions={slackOptions}
        selectedSlackChannel={selectedSlackChannel}
        handleSlackChannelSelect={handleSlackChannelSelect}
      />
      <LTButton
        onClick={InstallSlackPlugWithChannel}
        variant={LTButton.Variant.PRIMARY}
        disabled={isLoading || selectedSlackChannel ? false : true}
        className="self-start"
      >
        Install
      </LTButton>
    </LeftPanel>
  );
};

export default Slack;
